import { startSending, endSending } from "../progress/pogressSlice";
import * as api from '../../api';
import { url } from "../../api";
import { saveAs } from "file-saver";
import { serverErrors } from "../";

export const createFile = async(path, data, dispatch) => {
    dispatch(startSending())
    try {
        await api.downloadPDF(path, data)
        dispatch(endSending())
        return window.location.href = `${url}/download`
    } catch (error) {
        console.log(error);
        return dispatch(serverErrors(error, endSending))
    }
}

export const createBackUp = async (dispatch) => {
    dispatch(startSending())
    try {
        const { data} = await api.createBackUp()
        dispatch(endSending())
        const blob = new Blob([data], { type: 'octet-stream' })
        saveAs(blob, 'backup_DB_events.sql')
    } catch (error) {
        console.log(error);
        return dispatch(serverErrors(error, endSending))
    }
}